"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _preact = require("preact");

var _core = require("@uppy/core");

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var getFileTypeExtension = require("@uppy/utils/lib/getFileTypeExtension");

var supportsMediaRecorder = require("./supportsMediaRecorder.js");

var RecordingScreen = require("./RecordingScreen.js");

var PermissionsScreen = require("./PermissionsScreen.js");

var locale = require("./locale.js");

var packageJson = {
  "version": "0.3.0"
};
/**
 * Audio recording plugin
 */

var _stream = /*#__PURE__*/_classPrivateFieldLooseKey("stream");

var _audioActive = /*#__PURE__*/_classPrivateFieldLooseKey("audioActive");

var _recordingChunks = /*#__PURE__*/_classPrivateFieldLooseKey("recordingChunks");

var _recorder = /*#__PURE__*/_classPrivateFieldLooseKey("recorder");

var _capturedMediaFile = /*#__PURE__*/_classPrivateFieldLooseKey("capturedMediaFile");

var _mediaDevices = /*#__PURE__*/_classPrivateFieldLooseKey("mediaDevices");

var _supportsUserMedia = /*#__PURE__*/_classPrivateFieldLooseKey("supportsUserMedia");

var _hasAudioCheck = /*#__PURE__*/_classPrivateFieldLooseKey("hasAudioCheck");

var _start = /*#__PURE__*/_classPrivateFieldLooseKey("start");

var _startRecording = /*#__PURE__*/_classPrivateFieldLooseKey("startRecording");

var _stopRecording = /*#__PURE__*/_classPrivateFieldLooseKey("stopRecording");

var _discardRecordedAudio = /*#__PURE__*/_classPrivateFieldLooseKey("discardRecordedAudio");

var _submit = /*#__PURE__*/_classPrivateFieldLooseKey("submit");

var _stop = /*#__PURE__*/_classPrivateFieldLooseKey("stop");

var _getAudio = /*#__PURE__*/_classPrivateFieldLooseKey("getAudio");

var _changeSource = /*#__PURE__*/_classPrivateFieldLooseKey("changeSource");

var _updateSources = /*#__PURE__*/_classPrivateFieldLooseKey("updateSources");

var Audio = /*#__PURE__*/function (_core$UIPlugin) {
  _inherits(Audio, _core$UIPlugin);

  var _super = _createSuper(Audio);

  function Audio(uppy, opts) {
    var _this2;

    _classCallCheck(this, Audio);

    var _this;

    _this2 = _super.call(this, uppy, opts);
    _this = _assertThisInitialized(_this2);
    Object.defineProperty(_assertThisInitialized(_this2), _getAudio, {
      value: _getAudio2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _hasAudioCheck, {
      value: _hasAudioCheck2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _stream, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _audioActive, {
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this2), _recordingChunks, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _recorder, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _capturedMediaFile, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _mediaDevices, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _supportsUserMedia, {
      writable: true,
      value: null
    });
    Object.defineProperty(_assertThisInitialized(_this2), _start, {
      writable: true,
      value: function value(options) {
        if (options === void 0) {
          options = null;
        }

        if (!_classPrivateFieldLooseBase(_this, _supportsUserMedia)[_supportsUserMedia]) {
          return Promise.reject(new Error('Microphone access not supported'));
        }

        _classPrivateFieldLooseBase(_this, _audioActive)[_audioActive] = true;

        _classPrivateFieldLooseBase(_this, _hasAudioCheck)[_hasAudioCheck]().then(function (hasAudio) {
          _this.setPluginState({
            hasAudio: hasAudio
          }); // ask user for access to their camera


          return _classPrivateFieldLooseBase(_this, _mediaDevices)[_mediaDevices].getUserMedia({
            audio: true
          }).then(function (stream) {
            _classPrivateFieldLooseBase(_this, _stream)[_stream] = stream;
            var currentDeviceId = null;
            var tracks = stream.getAudioTracks();

            if (!options || !options.deviceId) {
              currentDeviceId = tracks[0].getSettings().deviceId;
            } else {
              tracks.forEach(function (track) {
                if (track.getSettings().deviceId === options.deviceId) {
                  currentDeviceId = track.getSettings().deviceId;
                }
              });
            } // Update the sources now, so we can access the names.


            _classPrivateFieldLooseBase(_this, _updateSources)[_updateSources]();

            _this.setPluginState({
              currentDeviceId: currentDeviceId,
              audioReady: true
            });
          }).catch(function (err) {
            _this.setPluginState({
              audioReady: false,
              cameraError: err
            });

            _this.uppy.info(err.message, 'error');
          });
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _startRecording, {
      writable: true,
      value: function value() {
        // only used if supportsMediaRecorder() returned true
        // eslint-disable-next-line compat/compat
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder] = new MediaRecorder(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stream)[_stream]);
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks] = [];
        var stoppingBecauseOfMaxSize = false;

        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].addEventListener('dataavailable', function (event) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks].push(event.data);

          var restrictions = _this2.uppy.opts.restrictions;

          if (_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks].length > 1 && restrictions.maxFileSize != null && !stoppingBecauseOfMaxSize) {
            var totalSize = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks].reduce(function (acc, chunk) {
              return acc + chunk.size;
            }, 0); // Exclude the initial chunk from the average size calculation because it is likely to be a very small outlier


            var averageChunkSize = (totalSize - _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks][0].size) / (_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks].length - 1);
            var expectedEndChunkSize = averageChunkSize * 3;
            var maxSize = Math.max(0, restrictions.maxFileSize - expectedEndChunkSize);

            if (totalSize > maxSize) {
              stoppingBecauseOfMaxSize = true;

              _this2.uppy.info(_this2.i18n('recordingStoppedMaxSize'), 'warning', 4000);

              _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stopRecording)[_stopRecording]();
            }
          }
        }); // use a "time slice" of 500ms: ondataavailable will be called each 500ms
        // smaller time slices mean we can more accurately check the max file size restriction


        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].start(500); // Start the recordingLengthTimer if we are showing the recording length.


        _this2.recordingLengthTimer = setInterval(function () {
          var currentRecordingLength = _this2.getPluginState().recordingLengthSeconds;

          _this2.setPluginState({
            recordingLengthSeconds: currentRecordingLength + 1
          });
        }, 1000);

        _this2.setPluginState({
          isRecording: true
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _stopRecording, {
      writable: true,
      value: function value() {
        var stopped = new Promise(function (resolve) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].addEventListener('stop', function () {
            resolve();
          });

          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].stop();

          clearInterval(_this2.recordingLengthTimer);

          _this2.setPluginState({
            recordingLengthSeconds: 0
          });
        });
        return stopped.then(function () {
          _this2.setPluginState({
            isRecording: false
          });

          return _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getAudio)[_getAudio]();
        }).then(function (file) {
          try {
            _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _capturedMediaFile)[_capturedMediaFile] = file; // create object url for capture result preview

            _this2.setPluginState({
              recordedAudio: URL.createObjectURL(file.data)
            });
          } catch (err) {
            // Logging the error, exept restrictions, which is handled in Core
            if (!err.isRestriction) {
              _this2.uppy.log(err);
            }
          }
        }).then(function () {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks] = null;
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder] = null;
        }, function (error) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks] = null;
          _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder] = null;
          throw error;
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _discardRecordedAudio, {
      writable: true,
      value: function value() {
        _this2.setPluginState({
          recordedAudio: null
        });

        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _capturedMediaFile)[_capturedMediaFile] = null;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _submit, {
      writable: true,
      value: function value() {
        try {
          if (_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _capturedMediaFile)[_capturedMediaFile]) {
            _this2.uppy.addFile(_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _capturedMediaFile)[_capturedMediaFile]);
          }
        } catch (err) {
          // Logging the error, exept restrictions, which is handled in Core
          if (!err.isRestriction) {
            _this2.uppy.log(err, 'error');
          }
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _stop, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var audioTracks;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stream)[_stream]) {
                    audioTracks = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stream)[_stream].getAudioTracks();
                    audioTracks.forEach(function (track) {
                      return track.stop();
                    });
                  }

                  if (!_classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder]) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return new Promise(function (resolve) {
                    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].addEventListener('stop', resolve, {
                      once: true
                    });

                    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder].stop();

                    clearInterval(_this2.recordingLengthTimer);
                  });

                case 4:
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recordingChunks)[_recordingChunks] = null;
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _recorder)[_recorder] = null;
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _audioActive)[_audioActive] = false;
                  _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stream)[_stream] = null;

                  _this2.setPluginState({
                    recordedAudio: null,
                    isRecording: false,
                    recordingLengthSeconds: 0
                  });

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function value() {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    Object.defineProperty(_assertThisInitialized(_this2), _changeSource, {
      writable: true,
      value: function value(deviceId) {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _stop)[_stop]();

        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _start)[_start]({
          deviceId: deviceId
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _updateSources, {
      writable: true,
      value: function value() {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _mediaDevices)[_mediaDevices].enumerateDevices().then(function (devices) {
          _this2.setPluginState({
            audioSources: devices.filter(function (device) {
              return device.kind === 'audioinput';
            })
          });
        });
      }
    });
    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _mediaDevices)[_mediaDevices] = navigator.mediaDevices;
    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _supportsUserMedia)[_supportsUserMedia] = _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _mediaDevices)[_mediaDevices] != null;
    _this2.id = _this2.opts.id || 'Audio';
    _this2.type = 'acquirer';

    _this2.icon = function () {
      return (0, _preact.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32"
      }, (0, _preact.h)("g", {
        fill: "none",
        "fill-rule": "evenodd"
      }, (0, _preact.h)("rect", {
        fill: "#9B59B6",
        width: "32",
        height: "32",
        rx: "16"
      }), (0, _preact.h)("path", {
        d: "M16 20c-2.21 0-4-1.71-4-3.818V9.818C12 7.71 13.79 6 16 6s4 1.71 4 3.818v6.364C20 18.29 18.21 20 16 20zm-6.364-7h.637c.351 0 .636.29.636.65v1.95c0 3.039 2.565 5.477 5.6 5.175 2.645-.264 4.582-2.692 4.582-5.407V13.65c0-.36.285-.65.636-.65h.637c.351 0 .636.29.636.65v1.631c0 3.642-2.544 6.888-6.045 7.382v1.387h2.227c.351 0 .636.29.636.65v.65c0 .36-.285.65-.636.65h-6.364a.643.643 0 0 1-.636-.65v-.65c0-.36.285-.65.636-.65h2.227v-1.372C11.637 22.2 9 19.212 9 15.6v-1.95c0-.36.285-.65.636-.65z",
        fill: "#FFF",
        "fill-rule": "nonzero"
      })));
    };

    _this2.defaultLocale = locale;
    _this2.opts = _objectSpread({}, opts);

    _this2.i18nInit();

    _this2.title = _this2.i18n('pluginNameAudio');

    _this2.setPluginState({
      hasAudio: false,
      audioReady: false,
      cameraError: null,
      recordingLengthSeconds: 0,
      audioSources: [],
      currentDeviceId: null
    });

    return _this2;
  }

  _createClass(Audio, [{
    key: "render",
    value: function render() {
      if (!_classPrivateFieldLooseBase(this, _audioActive)[_audioActive]) {
        _classPrivateFieldLooseBase(this, _start)[_start]();
      }

      var audioState = this.getPluginState();

      if (!audioState.audioReady || !audioState.hasAudio) {
        return (0, _preact.h)(PermissionsScreen, {
          icon: this.icon,
          i18n: this.i18n,
          hasAudio: audioState.hasAudio
        });
      }

      return (0, _preact.h)(RecordingScreen // eslint-disable-next-line react/jsx-props-no-spreading
      , _extends({}, audioState, {
        audioActive: _classPrivateFieldLooseBase(this, _audioActive)[_audioActive],
        onChangeSource: _classPrivateFieldLooseBase(this, _changeSource)[_changeSource],
        onStartRecording: _classPrivateFieldLooseBase(this, _startRecording)[_startRecording],
        onStopRecording: _classPrivateFieldLooseBase(this, _stopRecording)[_stopRecording],
        onDiscardRecordedAudio: _classPrivateFieldLooseBase(this, _discardRecordedAudio)[_discardRecordedAudio],
        onSubmit: _classPrivateFieldLooseBase(this, _submit)[_submit],
        onStop: _classPrivateFieldLooseBase(this, _stop)[_stop],
        i18n: this.i18n,
        showAudioSourceDropdown: this.opts.showAudioSourceDropdown,
        supportsRecording: supportsMediaRecorder(),
        recording: audioState.isRecording,
        stream: _classPrivateFieldLooseBase(this, _stream)[_stream]
      }));
    }
  }, {
    key: "install",
    value: function install() {
      var _this3 = this;

      this.setPluginState({
        audioReady: false,
        recordingLengthSeconds: 0
      });
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }

      if (_classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices]) {
        _classPrivateFieldLooseBase(this, _updateSources)[_updateSources]();

        _classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices].ondevicechange = function () {
          _classPrivateFieldLooseBase(_this3, _updateSources)[_updateSources]();

          if (_classPrivateFieldLooseBase(_this3, _stream)[_stream]) {
            var restartStream = true;

            var _this3$getPluginState = _this3.getPluginState(),
                audioSources = _this3$getPluginState.audioSources,
                currentDeviceId = _this3$getPluginState.currentDeviceId;

            audioSources.forEach(function (audioSource) {
              if (currentDeviceId === audioSource.deviceId) {
                restartStream = false;
              }
            });

            if (restartStream) {
              _classPrivateFieldLooseBase(_this3, _stop)[_stop]();

              _classPrivateFieldLooseBase(_this3, _start)[_start]();
            }
          }
        };
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (_classPrivateFieldLooseBase(this, _stream)[_stream]) {
        _classPrivateFieldLooseBase(this, _stop)[_stop]();
      }

      this.unmount();
    }
  }]);

  return Audio;
}(_core.UIPlugin);

function _hasAudioCheck2() {
  if (!_classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices]) {
    return Promise.resolve(false);
  }

  return _classPrivateFieldLooseBase(this, _mediaDevices)[_mediaDevices].enumerateDevices().then(function (devices) {
    return devices.some(function (device) {
      return device.kind === 'audioinput';
    });
  });
}

function _getAudio2() {
  // Sometimes in iOS Safari, Blobs (especially the first Blob in the recordingChunks Array)
  // have empty 'type' attributes (e.g. '') so we need to find a Blob that has a defined 'type'
  // attribute in order to determine the correct MIME type.
  var mimeType = _classPrivateFieldLooseBase(this, _recordingChunks)[_recordingChunks].find(function (blob) {
    var _blob$type;

    return ((_blob$type = blob.type) == null ? void 0 : _blob$type.length) > 0;
  }).type;

  var fileExtension = getFileTypeExtension(mimeType);

  if (!fileExtension) {
    return Promise.reject(new Error("Could not retrieve recording: Unsupported media type \"".concat(mimeType, "\"")));
  }

  var name = "audio-".concat(Date.now(), ".").concat(fileExtension);
  var blob = new Blob(_classPrivateFieldLooseBase(this, _recordingChunks)[_recordingChunks], {
    type: mimeType
  });
  var file = {
    source: this.id,
    name: name,
    data: new Blob([blob], {
      type: mimeType
    }),
    type: mimeType
  };
  return Promise.resolve(file);
}

Audio.VERSION = packageJson.version;
module.exports = Audio;